
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import "./index.css";  // Importuje globální styly
const GA4_MEASUREMENT_ID = "G-116WZRYES6";

function Analytics() {
    const location = useLocation();
    const didTrackInitial = useRef(false);

    useEffect(() => {
        // First pageview is already handled by the GA snippet in index.html.
        if (!didTrackInitial.current) {
            didTrackInitial.current = true;
            return;
        }

        const path = `${location.pathname}${location.search}${location.hash}`;
        if (typeof window !== "undefined" && typeof window.gtag === "function") {
            window.gtag("config", GA4_MEASUREMENT_ID, { page_path: path });
        }
    }, [location]);

    return null;
}

function App() {
    return (
        <Router>
            <Analytics />
            <Routes>
                <Route path="/" element={<Home />} />
                {/* Catch-all route pro neexistující cesty */}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Router>
    );
}

export default App;
